export const style = {
  h4: {
    fontSize: `22px`,
    fontWeight: 300,
    color: `black`,
    margin: `0 0 32px 0`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/UserEditor/style/ColorBlind/headers.js